'use strict';

var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
var Node = require('./node');
var Comment = /*#__PURE__*/function (_Node) {
  _inherits(Comment, _Node);
  var _super = _createSuper(Comment);
  function Comment(defaults) {
    var _this;
    _classCallCheck(this, Comment);
    _this = _super.call(this, defaults);
    _this.type = 'comment';
    return _this;
  }
  return _createClass(Comment);
}(Node);
module.exports = Comment;
Comment.default = Comment;